import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["height", "width"];
import styled from 'styled-components';
import { useMapTokenPropsToCSS } from 'foundations-components/hooks/useMapTokenPropsToCSS';
import { filterTokenProps } from 'foundations-components/utils/filterTokenProps';
import { jsx as _jsx } from "react/jsx-runtime";
const LoadingSkeletonInner = styled.div.attrs({
  'data-loading': 'true'
})(({
  height,
  width,
  theme: _theme,
  $spaceCssStyles
}) => {
  const theme = _theme;
  return {
    '@keyframes pulse': {
      from: {
        backgroundColor: theme.color['fill-primary-disabled']
      },
      to: {
        backgroundColor: theme.color['fill-tertiary-pressed']
      }
    },
    '@media (prefers-reduced-motion)': {
      animation: 'none'
    },
    '&&&': Object.assign({
      backgroundColor: theme.color['fill-primary-disabled'],
      borderRadius: '4px',
      height,
      width,
      animation: '2s ease-in-out 0s infinite alternate both running pulse'
    }, $spaceCssStyles)
  };
});

/**
 * A versatile loading skeleton, used as a building block for loading states.
 *
 * Includes pulse animation to indicate the loading state.
 *
 * Supports:
 * - height and width (e.g. '18px')
 * - certain Trellis token props: SpaceStyleProps and DOMAttributes
 */
export const LoadingSkeleton = _ref => {
  let {
      height,
      width
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    tokenProps,
    restProps
  } = filterTokenProps(props);
  const spaceCssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(LoadingSkeletonInner, Object.assign({
    height: height,
    width: width,
    $spaceCssStyles: spaceCssStyles
  }, restProps));
};